module.exports = __webpack_public_path__ + "img/hest9.3dade0bd.jpg";